// components/industry-templates/LegalEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Scale, FileText, Users, Award } from 'lucide-react';

export const LegalEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Legal Sessions */}
      {industryData?.legal_sessions && (
        <Card className="border-0 bg-gradient-to-br from-slate-700/20 to-gray-700/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Scale className="w-8 h-8" style={{ color: theme.primary }} />
              Legal Sessions & Panels
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {industryData.legal_sessions.map((session: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl">
                  <h3 className="text-xl font-bold text-white mb-2">{session.topic}</h3>
                  <p className="text-slate-300 text-sm mb-3">{session.description}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{session.speaker}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Practice Areas */}
      {industryData?.practice_areas && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Legal Practice Areas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-2">
              {industryData.practice_areas.map((area: string, idx: number) => (
                <Badge key={idx} style={{ backgroundColor: theme.primary }} className="text-sm py-2 px-4">
                  {area}
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
